var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask"},[_c('div',{staticClass:"loading-box"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("../../assets/image/loading_white.png")}}),_c('div',{staticClass:"loading-text"},[_vm._v("loading...")])])])
}]

export { render, staticRenderFns }